<h2>{{ 'Embed external media into the content of the annotation' | translate }}</h2>

<div style="display: grid; grid-template-columns: 1fr 1fr; gap: 8px">
  <k-input [label]="'URL' | translate" #url />
  <k-input [label]="'Fallback media description' | translate" #description />
</div>

<k-button-row justify="end">
  <k-button
    type="solid-primary"
    (click)="
      addImage(url.value(), description.value()); url.value.set(''); description.value.set('')
    "
  >
    <span>{{ 'Add' | translate }}</span>
  </k-button>
</k-button-row>

<!--
TODO: Die Funktion muss noch mal überdacht/ausgereift werden. Wenn man hier drauf drückt,
wird im DialogannotationEditor eine Methode getriggert, die rohes HTML in den Annotationscontent einsetzt.
Zusammen mit dem Markdown Compiler könnte man aber z.B. festlegen, dass eine echte Entity-Card als Component eingesetzt wird, etc pp.

@if (compilation$ | async) {
<k-details [title]="'Add Entity From Collection' | translate" [startCollapsed]="true">
  <p>{{ 'Click on an entity to add it to the annotation' | translate }}</p>
  @for (entity of entities$ | async; track entity; let i = $index) {
  <mat-card appearance="outlined" (click)="addEntity(i)" class="compilation-entity">
    <img mat-card-image [src]="server_url + entity.settings.preview" [alt]="entity.name" />
    <mat-card-footer>{{ entity.name }}</mat-card-footer>
  </mat-card>
  }
</k-details>
}
-->
